export default function header() {

    const headerSearch = document.querySelector('.js-header-search');
    const headerSearchClose = document.querySelector('.js-header-search-close');
    const headerHideElements = document.querySelectorAll('.js-header-hide-elemnet');
    const headerSearchInput = document.querySelector('.js-header-search-input');
    const headerSearchOut = document.querySelector('.js-header-search-out');

    const headerSearchMobile = document.querySelector('.js-header-search-mobile');
    const headerSearchMobileClose = document.querySelector('.js-header-search-mobile-close');
    const headerSearchMobileInput = document.querySelector('.js-header-search-mobile-input');
    const headerSearchMobileOut = document.querySelector('.js-header-search-mobile-out');

    let searchIsOpen = 0;

    const headerClubChoice = document.querySelector('.js-header-club-choice');
    const headerClubChoiceMobile = document.querySelector('.js-header-club-choice-mobile');

    if ( headerClubChoice ) {
        let headerClubDrop = headerClubChoice.querySelector('.header__club-drop');
        if ( headerClubDrop ) {
            headerClubChoice.addEventListener('click',function(){
                headerClubDrop.classList.toggle('open');
            });
            document.addEventListener('keydown',function(e){
                if ( e.key === 'Escape' ) {
                    headerClubDrop.classList.remove('open');
                }
            });
            for (let section of document.querySelectorAll('section') ) {
                section.addEventListener('click',function(){
                    headerClubDrop.classList.remove('open');
                });
            }
        }
        
    }

    if ( headerClubChoiceMobile ) {
        let headerClubDrop = headerClubChoiceMobile.querySelector('.header__club-drop');
        if ( headerClubDrop ) {
            headerClubChoiceMobile.addEventListener('click',function(){
                headerClubDrop.classList.toggle('open');
            });
            document.addEventListener('keydown',function(e){
                if ( e.key === 'Escape' ) {
                    headerClubDrop.classList.remove('open');
                }
            });
            for (let section of document.querySelectorAll('section') ) {
                section.addEventListener('click',function(){
                    headerClubDrop.classList.remove('open');
                });
            }
        }
    }

    

    if ( headerSearch && headerHideElements.length ) {
        headerSearch.addEventListener('click',function(){

            if ( searchIsOpen == 0 ) {

                for (let el of headerHideElements ) {
                    el.style.opacity = "0";
                
                    setTimeout(() => {
                        el.classList.add("d-none"); 
                        headerSearch.classList.add("ml-auto");

                        headerSearch.classList.add("active");
                        setTimeout(() => {
                            headerSearch.classList.add("show");
                        }, 100);
                    }, 300);
                    
                }

                searchIsOpen = 1;
            }

            
        });
    }

    if ( headerSearchClose && headerSearch && headerHideElements.length ) {
        headerSearchClose.addEventListener('click',function(){

            if ( searchIsOpen == 1 ) {

                headerSearch.classList.remove("show");

                setTimeout(() => {

                    for (let el of headerHideElements ) {
                        setTimeout(() => {
                            el.classList.remove("d-none");
                        }, 150);
                        setTimeout(() => {
                            el.style.opacity = "1";
                            headerSearch.classList.remove("ml-auto")
                        }, 300);
                    }

                    headerSearch.classList.remove("active");

                    searchIsOpen = 0;

                }, 100);

            }

        });
    }



    for (let section of document.querySelectorAll('section') ) {
        section.addEventListener('click',function(){
            if ( searchIsOpen == 1 ) {

                headerSearch.classList.remove("show");

                setTimeout(() => {

                    for (let el of headerHideElements ) {
                        setTimeout(() => {
                            el.classList.remove("d-none");
                        }, 150);
                        setTimeout(() => {
                            el.style.opacity = "1";
                            headerSearch.classList.remove("ml-auto")
                        }, 300);
                    }

                    headerSearch.classList.remove("active");

                    searchIsOpen = 0;

                }, 100);

            }
        });
    }

    if ( headerSearchOut && headerSearchInput ) {
        headerSearchInput.addEventListener('input',function(){
            let value = headerSearchInput.value;
            headerSearchOut.href = `/?s=${value}`;
        });

        headerSearchInput.addEventListener('keydown',function(e){
            if ( e.key === 'Enter' ) {
                let value = headerSearchInput.value;
                headerSearchOut.href = `/?s=${value}`;
                location.href = headerSearchOut.href;
            }
        });

    }
    

    if ( headerSearchMobile && headerHideElements.length ) {
        headerSearchMobile.addEventListener('click',function(){

            if ( searchIsOpen == 0 ) {
                for (let el of headerHideElements ) {
                    el.style.opacity = "0";
                    //el.style.position = "absolute";
                    setTimeout(() => {
                        headerSearchMobile.classList.add("ml-auto");
                        el.classList.add("d-none"); 
                        headerSearchMobile.classList.add("active");
                    }, 300);
                }
                searchIsOpen = 1;
            }

            
        });
    }

    if ( headerSearchMobileClose && headerSearchMobile && headerHideElements.length ) {
        headerSearchMobileClose.addEventListener('click',function(){

            if ( searchIsOpen == 1 ) {
                setTimeout(() => {

                    headerSearchMobile.classList.remove("ml-auto");
                    headerSearchMobile.classList.remove("active");
                    
    
                    for (let el of headerHideElements ) {
                        el.classList.remove("d-none");
                        setTimeout(() => {
                            el.style.opacity = "1";
                        
                        }, 300);
                        //el.style.position = "relative";
                    }
    
                
                    searchIsOpen = 0;
                }, 100);
            }

            

        });
    }

    if ( headerSearchMobileInput && headerSearchMobile ) {
        headerSearchMobileInput.addEventListener('input',function(){
            let value = headerSearchMobileInput.value;
            headerSearchMobileOut.href = `/?s=${value}`;
        });

        headerSearchMobileInput.addEventListener('keydown',function(e){
            if ( e.key === 'Enter' ) {
                let value = headerSearchMobileInput.value;
                headerSearchMobileOut.href = `/?s=${value}`;
                location.href = headerSearchMobileOut.href;
            }
        });
    }

    



}